<section fxLayout="column" class="overflow-hidden h-100 pt-4 pb-2 px-5">
    <section fxFlex="1 1 auto" class="px-5 overflow-auto">
        <h2>{{translate.getLng('ITEM_LIST')}}</h2>
      <span>{{translate.getLng('SEE_PRICES_IN_PROJECT')}} </span>
        <sen-app-items-quantity [tableData]="itemList"></sen-app-items-quantity>
    </section>
    <section>
        <div class="mt-2" fxLayout="row" fxLayoutAlign="flex-end center">
            <button mat-raised-button class="px-5 py-2" color="primary"
                [routerLink]="[prevPath]">{{translate.getLng('PREV')}}</button>
            <button (click)="roofPlanSave(nextPath)" mat-raised-button class="px-5 py-2 ml-2"
                color="primary">{{translate.getLng('SAVE')}}
            </button>
            <!-- <button mat-raised-button class="px-5 py-2 ml-2" color="primary"
                [matMenuTriggerFor]="menu">{{translate.getLng('SAVE')}}
                <mat-icon class="pl-4">keyboard_arrow_up</mat-icon>
            </button>
            <mat-menu #menu="matMenu" yPosition="above">
                <button mat-menu-item class="sen-fs10"
                    (click)="roofPlanSave(nextPath)">{{translate.getLng('SAVE_PROCEED_TO_MANAGE')}}</button>
                <button mat-menu-item class="sen-fs10"
                    (click)="roofPlanSave(inverterPath)">{{translate.getLng('SAVE_PROCEED_TO_CREATE')}}</button>
            </mat-menu> -->
        </div>
    </section>
</section>
